// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>16</span>&nbsp;&nbsp;My delight shall be in your statutes&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and I will not forget your word.<br> </p> </div></div>";
// Exports
module.exports = code;